import * as links from '../../../constants/links';

export default [
  [`^/?$`, {
    title: 'Index Route',
    main: null,
    public: 1,
  }],
  [`^${links.LINK_SIGN_IN}/?$`, {
    title: 'Sign in',
    main: require('../../../components/pages/Auth/SignIn'),
    public: 1,
  }],
  [`^${links.LINK_TFA_VERIFICATION}/?$`, {
    title: '2FA verification',
    main: require('../../../components/pages/Auth/TfaVerification'),
    public: 1,
  }],
  [`^${links.LINK_TFA_RESET}/?$`, {
    title: '2FA verification',
    main: require('../../../components/pages/Auth/TfaReset'),
    public: 1,
  }],
  [`^${links.LINK_PASSWORD_FORGOT}/?$`, {
    title: 'Password recovery',
    main: require('../../../components/pages/Auth/PasswordForgot'),
    public: 1,
  }],
  [`^${links.LINK_PASSWORD_RESET}(/([^/]+):token)?$`, {
    title: 'Password recovery',
    main: require('../../../components/pages/Auth/PasswordReset'),
    public: 1,
  }],
  [`^${links.LINK_PASSWORD_SETUP}/?$`, {
    title: 'Password setup',
    main: require('../../../components/pages/Auth/PasswordSetup'),
    public: 1,
  }]
];
